import {
    selectAPIBaseURL,
    selectAuthenticatedUser,
    selectAuthEnvironment,
    useSelector
} from '@missionlabs/api'
import { populateUrl } from '@missionlabs/utils'
import { useCallback, useState } from 'react'

import { Features } from './useHasClientFeature'
import { useHasFeature } from './useHasFeature'

export const useWhatsAppDownloadMedia = () => {
    const isWhatsAppEnabled = useHasFeature(Features.whatsapp)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    // Get environment and user info from state
    const { environment, dataCentre, country, product } = useSelector(selectAuthEnvironment)
    const API_BASE_URL = useSelector(selectAPIBaseURL)
    const user = useSelector(selectAuthenticatedUser)

    const apiBaseUrl = populateUrl(API_BASE_URL, { dataCentre, environment, country, product })

    const downloadWhatsAppMedia = useCallback(
        async (url: string) => {
            if (!isWhatsAppEnabled || !url) return undefined
            if (!user?.clientID || !user?.token) return undefined

            // Build the full URL
            const headers = { 'X-TOKEN': user.token }
            const fullUrl = `${apiBaseUrl}/messaging/whatsapp/clients/${
                user.clientID
            }/media?url=${encodeURIComponent(url)}`

            setError(null)
            setLoading(true)

            try {
                const response = await fetch(fullUrl, { method: 'GET', headers })
                if (!response.ok) throw new Error('Failed to fetch media')
                const blob = await response.blob()
                setLoading(false)

                return {
                    url: URL.createObjectURL(blob),
                    type: blob.type
                }
            } catch (err) {
                setLoading(false)
                setError((err as Error).message)
                return undefined
            }
        },
        [apiBaseUrl, isWhatsAppEnabled, user]
    )

    return { downloadWhatsAppMedia, loading, error }
}
